import Vue from "vue";
import Vuex from "vuex";
import * as comanStore from "./module/comanStore";
import * as Users from "./module/auth";
import * as cashStore from "./module/cashStore";
import * as customers from "./module/customerStore";
import * as links from "./module/links";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    comanStore,
    Users,
    cashStore,
    customers,
    links,
  },
});
